<template>

<input type="hidden" value="{{ dati.id }}" name="id">
        <div class="grid grid-cols-3 gap-4">
            
            <div class="mt-3 mb-3 ml-3">
                <label for="mittente_mail" class="block text-gray-700 text-sm font-bold mb-2">
                    Mittente
                </label>
                <InputText name="mittente_mail" v-model="form_data.mittente_mail" class="w-full" />
                
            </div>
            
            <div class="mt-3 mb-3 ">
                <label for="destinatario_mail" class="block text-gray-700 text-sm font-bold mb-2 mr-2">
                    Destinatario
                </label>
                <Select class="w-full" v-model="form_data.destinatario_mail" :options="destinatario_options" optionLabel="label" optionValue="value" ></Select>
                <InputText class="w-full" type="email" v-if="form_data.destinatario_mail == 'custom'" v-model="form_data.destinatario_mail_custom" name="destinatario_mail" placeholder="Inserisci email" />
                <Message v-if="errors !== undefined && 'destinatario' in errors" severity="error" size="small" variant="simple">
					{{ errors[key] }}
				</Message>
            </div>
            
            <div class="mt-3 mb-3 mr-3">
                <label for="cc" class="block text-gray-700 text-sm font-bold mb-2">
                    CC
                </label>
                <InputText class="w-full" v-model="form_data.cc" name="cc" />
                <Message v-if="errors !== undefined && 'cc' in errors" severity="error" size="small" variant="simple">
					{{ errors[key] }}
				</Message>
                
            </div>
        </div>
        <div class="grid grid-cols-2 gap-4">

            <div>
                <label for="oggetto" class="block text-gray-700 text-sm font-bold mb-2 ml-3">
                    Oggetto
                </label>
                <div class=" mb-3 ml-3">

                    <InputGroup class="w-full">
                        <InputGroupAddon>
                            Appalto
                        </InputGroupAddon>
                        <InputText v-model="form_data.oggetto" name="oggetto" />
                    </InputGroup>
                </div>
            </div>
            <div class="mb-3 mr-3">
                <label for="allegati" class="block text-gray-700 text-sm font-bold mb-2">
                    Allegati
                </label>
                <FileUpload
                    class="w-full"
					name="allegati[]"
					mode="basic"
					@select="(event) => onFileSelect(event, key)"
					:maxFileSize="20000000"
					:chooseLabel="$root.trans.scegli_file"
				/>
                
                <input type="checkbox" name="allegato_check" v-model="form_data.allega_ddt" value="{{ dati.id }}" >
                <label for="allegato_check" class="mt-3 ml-2">
                    DDT: {{ dati.id }}
                </label>
            </div>
        </div>

        <div class="ml-3 mr-3 mb-3">
            <label for="messaggio" class="block text-gray-700 text-sm font-bold mb-2">
                Messaggio
            </label>
            <Textarea class="w-full" v-model="form_data.messaggio" name="messaggio"  cols="25" rows="25" ></Textarea>    
           
        </div>
        <div v-if="inviata >= 1" class="ml-3 mr-3 mb-3" style="background-color: lightcoral; padding:5px; color:white">EMAIL GIA' INVIATA</div>
        <div class="mr-3 mb-3 text-right">
            <a type="button" class="bottone-annulla btn btn-secondario mt-4 mr-2" :href="rotta_ddt">Annulla</a>
            <button @click="invia" class="bottone-salva btn btn-primario mt-4 mr-2">Invia</button>
        </div>

</template>
<script>
import  InputText  from 'primevue/inputtext';    
import Select from 'primevue/select';
import  Textarea  from 'primevue/textarea';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import FileUpload from 'primevue/fileupload';
import Message from 'primevue/message';

import axios from 'axios';



export default {
	name: "DdtInviaForm",
	components: {
		InputText,
		Select,
		Textarea,
        InputGroup,
        InputGroupAddon,
        FileUpload
	},
	props: ['dati_ddt', 'default_mail', 'cliente_email','cantiere_email', 'firma_email', 'giainviata', 'route_email', 'route_ddt'],
	data() {
		return {
            rotta_email: this.route_email,
            rotta_ddt: this.route_ddt,
            inviata: this.giainviata,
			dati: JSON.parse(this.dati_ddt),
            mail_cliente: this.cliente_email,
            mail_cantiere: this.cantiere_email,
            mail_firma: this.firma_email,
            errors: {},
            form_data : {
                id: JSON.parse(this.dati_ddt).id,
                mittente_mail: this.default_mail,
                destinatario_mail: '',
                destinatario_mail_custom: '',
                oggetto: 'Invio DDT N. ' + JSON.parse(this.dati_ddt).numeratore,
                cc: '',
                allega_ddt: 0,
                allegati: [],
                messaggio: "Buongiorno,<br/>con la seguente siamo ad inviarle in allegato il DDT richiesto.<br/><br/>Grazie<br/>" + this.firma_email,
            },
            destinatario_options: [
                { label: "Email cliente: "+this.cliente_email, value: this.cliente_email }, 
                    
                { label: "Email cantiere: "+ this.cantiere_email, value:this.cantiere_email },
                {   label: 'Custom',  value: 'custom'  }
                
            ],
		};
	},
    methods: {
		onFileSelect: function (event, key) {
			this.form_data.allegati.push(...event.files);
		},
        invia: function(){
            console.log(this.form_data)

            if(this.form_data.destinatario_mail == 'custom'){
                this.form_data.destinatario_mail = this.form_data.destinatario_mail_custom;
            }
            axios.post(this.rotta_email, this.form_data,{
                headers:{
						'Content-Type': 'multipart/form-data',
                }
            })
            .then(response => {
                const data = response.data;
                if(data.success) {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: data.message, life: 3000 });
                    window.location.href = data.redirect;
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: data.message, life: 3000 });
                    this.errors[data.tipo] = data.error;
                }
                this.inviata = 1;
            })
            

        }
    }
}
</script>
